import { useEffect, useState } from "react";

/**
 * Countdown hook: returns remaining seconds given an initial value.
 * Resets when `initialSeconds` changes.
 */
export const useCountdown = (initialSeconds: number | null): number => {
  const [seconds, setSeconds] = useState<number>(initialSeconds ?? 0);

  useEffect(() => {
    setSeconds(initialSeconds ?? 0);
    if (!initialSeconds || initialSeconds <= 0) return;

    const interval = setInterval(() => {
      setSeconds((prev) => (prev <= 0 ? 0 : prev - 1));
    }, 1000);

    return () => clearInterval(interval);
  }, [initialSeconds]);

  return seconds;
};
